import { SxProps, Theme } from '@mui/material';
import Box from '@mui/material/Box';

import { OverflowAwareText } from '~components/Order/ordersDispatchStyledComponents';
import { Load } from '~hooks/useLoad/models';
import { dateFormat, formatDuration } from '~utils/dateTime';

interface DropoffTimeColumnProps {
  load: Load;
  sx?: SxProps<Theme>;
}

export default function DropoffTimeColumn({ load, sx }: DropoffTimeColumnProps) {
  const dropoffTime =
    load.loadSummary?.arrivedDropoffAt || load.loadSummary?.loadCompletedAt;

  return (
    <Box sx={sx}>
      {dropoffTime ? (
        <>
          <OverflowAwareText>{dateFormat(dropoffTime, 'hh:mm A')}</OverflowAwareText>

          <OverflowAwareText sx={(theme) => ({ color: theme.brandV2.colors.treadGray2 })}>
            {load.loadSummary?.dropoffTimeMinutes
              ? formatDuration(load.loadSummary?.dropoffTimeMinutes * 60)
              : '0m'}
          </OverflowAwareText>
        </>
      ) : (
        '-'
      )}
    </Box>
  );
}
